import { render, staticRenderFns } from "./UserSearchSwitchSimpleMode.vue?vue&type=template&id=a473e408&scoped=true"
import script from "./UserSearchSwitchSimpleMode.vue?vue&type=script&lang=ts"
export * from "./UserSearchSwitchSimpleMode.vue?vue&type=script&lang=ts"
import style0 from "./UserSearchSwitchSimpleMode.vue?vue&type=style&index=0&id=a473e408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a473e408",
  null
  
)

export default component.exports